import { useState } from "react";
import Layout from "./Layout";
import styles from "../styles/root.module.css"
import Cart from '../components/Cart';
import Login from "./Login";
import { Outlet, ScrollRestoration, useLocation } from "react-router-dom";

const Root = () => {
    const [viewCart, setViewCart] = useState(false);
    const [openLogin, setOpenLogin] = useState(false);
    const location = useLocation();

    const handleCartClick = () => setViewCart(prev => !prev);
    const handleAccountClick = () => setOpenLogin(prev => !prev);

    return (
        <div className={styles.rootContainer}>
            <ScrollRestoration />
            {
                location.pathname === '/admin' || location.pathname === '/admin/dashboard' 
                    ? '' 
                    : <Layout 
                        onCartClick={handleCartClick} 
                        onAccountClick={handleAccountClick}
                        viewCart={viewCart}
                        openLogin={openLogin}
                        />
            }
            <div>
               <Cart viewCart={viewCart} setViewCart={setViewCart}/>
                <Login openLogin={openLogin} setOpenLogin={setOpenLogin}/>
            </div>
            <main className={location.pathname === "/admin" || location.pathname === "/admin/dashboard" ? styles.main_admin : ""}>
                <Outlet context={{ handleAccountClick }}/>
            </main>
        </div>
    )
}

export default Root